import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/qa/mobileapp.webp";

function Banner(props) {
  return (
    <div className="mobileapp_gcc p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h2>
                Let Your Mobile App Become the Face of Your Business in the
                Global Marketplace
              </h2>
              <p className="main_para">
                We’re living in a world where conducting business through your
                smartphone has become the norm. Having a mobile app has become a
                necessity more than ever and that is what every business is
                prioritizing these days. Meanwhile, considering the competitive
                market of Qatar, you get no other choice than to digitize your
                business with a mobile app. Your mobile app must define your
                objective by portraying a digital identity of your business to
                interact with the users. That’s where TekRevol comes in to give
                you the perfect solution with its masterly team of app
                developers in Qatar. With a user-centric approach, we build an
                application that meets the customer’s expectations while
                streamlining the operations. Our Qatar app development company
                ensures that your app becomes the brand identity in the digital
                world rather than just a tool for operating a business. We
                enable you to discover the hidden perks of mobile apps that will
                boost your business growth.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="mobile app development company"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
